// hooks/useAnyLoading.js
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

/**
 * Returns true if any query or mutation key starts with the given prefix.
 *
 * @param {string} keyPrefix - The prefix to match (e.g., "payment_").
 * @returns {boolean} - True if any matching query/mutation is active.
 */
export const useAnyLoading = (keyPrefix = '') => {
  const totalFetching = useIsFetching({
    predicate: (query) => {
      const key = query.queryKey?.[0];
      const match = typeof key === 'string' && key.startsWith(keyPrefix);

      return match;
    },
  });

  const totalMutating = useIsMutating({
    predicate: (mutation) => {
      const key = mutation.options?.mutationKey?.[0];
      const match = typeof key === 'string' && key.startsWith(keyPrefix);
      return match;
    },
  });

  const isLoading = totalFetching > 0 || totalMutating > 0;

  return isLoading;
};
